import { render, staticRenderFns } from "./StudentRemarks.vue?vue&type=template&id=78703bd0"
import script from "./StudentRemarks.vue?vue&type=script&lang=js"
export * from "./StudentRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports